<template>
  <div>
    <div>
      <v-app-bar color="deep-purple accent-4" dense dark>
        <v-toolbar-title>Human Resources: Medical Insurance</v-toolbar-title>

        <v-spacer></v-spacer>
        <!--
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
-->
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <!--
              <v-avatar v-on="on" style="cursor: pointer;">
                <v-icon dark>mdi-account-circle</v-icon>
              </v-avatar> -->
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title>{{ userName }}</v-list-item-title>
            </v-list-item>
            <v-list-item style="cursor: pointer;">
              <router-link :to="{ name: 'sign-out' }">
                <v-list-item-title>Logout</v-list-item-title></router-link
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </div>
    <slot />
  </div>
</template>
<script>
import JwtService from "@/services/jwt.service";
export default {
  name: "hrlayout",
  data: () => ({
    items1: []
  }),
  computed: {
    userName() {
      return JwtService.getUser()
        ? JwtService.getUser()["user_firstname"] +
            " " +
            JwtService.getUser()["user_lastname"]
        : "";
    }
  }
};
</script>
<style scoped>
a {
  color: rgb(17, 16, 16);
  text-decoration: none;
}
</style>
